import { render, staticRenderFns } from "./phone-com.vue?vue&type=template&id=63756f32"
import script from "./phone-com.vue?vue&type=script&lang=js"
export * from "./phone-com.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports